var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_355_7541",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8455 0.306641H0.361816V19.7903H19.8455V0.306641Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_355_7541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.7188 6.39551H0.361816V19.7905H4.7188V6.39551Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5865 6.55258C16.5403 6.53799 16.4964 6.52212 16.4477 6.50872C16.3893 6.49533 16.3308 6.48441 16.2712 6.47469C16.0398 6.42835 15.7865 6.39551 15.4894 6.39551C12.9493 6.39551 11.3382 8.24283 10.8072 8.95643V6.39551H6.4502V19.7905H10.8072V12.4842C10.8072 12.4842 14.0999 7.89823 15.4894 11.2664C15.4894 14.273 15.4894 19.7905 15.4894 19.7905H19.8452V10.7514C19.8452 8.72743 18.4583 7.04095 16.5865 6.55258Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49285 4.56869C3.66973 4.56869 4.62385 3.61457 4.62385 2.43766C4.62385 1.26073 3.66973 0.306641 2.49285 0.306641C1.31591 0.306641 0.361816 1.26073 0.361816 2.43766C0.361816 3.61457 1.31591 4.56869 2.49285 4.56869Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIN.d56e462d3d05ee5b0e8c220e0cc0b35e.svg";
export { ForwardRef as ReactComponent };